import { useRef } from 'react';

import { useLegalClientRepresentativeSaveAddresses } from 'api/requests';
import { useFilesUpload, useServerErrorNotify } from 'hooks';
import { OnboardingRegistrationAddressFormType } from 'modules/onboarding/common/forms/onboardingRegistrationAddressForm';
import {
  getInitialData,
  getSubmitData,
} from 'modules/onboarding/common/helpers/registrationAddress';
import { useOnboardingCountries } from 'modules/onboarding/common/hooks';

import { useOnboardingContext } from './useOnboardingContext';

export const useRegistrationAddress = () => {
  const { goToBack, goToNext, data } = useOnboardingContext();
  const {
    saveAddresses,
    loading: submitLoading,
    error,
  } = useLegalClientRepresentativeSaveAddresses();

  const { countries, loading: countriesLoading } = useOnboardingCountries();

  const initialData = useRef(getInitialData(data.currentClient)).current;
  const initialValues = useRef(initialData?.values).current;

  const {
    files,
    isLoadingFile: submitDisabled,
    onRemoveFile,
    onAddFiles,
  } = useFilesUpload(initialData?.files);

  const onSubmit = async (values: OnboardingRegistrationAddressFormType) => {
    if (values) {
      const submitData = getSubmitData(values, true);
      const res = await saveAddresses(data.currentClient.id, submitData);
      if (res) {
        goToNext();
      }
    }
  };

  useServerErrorNotify(error);

  return {
    initialValues,
    countries,
    countriesLoading,
    files,
    submitLoading,
    submitDisabled,
    onSubmit,
    goToBack,
    onAddFiles,
    onRemoveFile,
  };
};
